/**
 * Zentrale Themenkonfiguration für die TimeSnap-App
 * Alle Farben erfüllen die WCAG 2.1 Kontrastanforderungen (mindestens 4.5:1)
 * @see https://www.w3.org/WAI/WCAG21/Understanding/contrast-minimum.html
 */

// Hauptfarbe der App
export const primaryColor = 'rgba(174,189,8,1)';
export const primaryColorHex = '#AEBD08';

// Hellere und dunklere Varianten für Hover- und Fokuszustände
export const primaryLightColor = 'rgba(200,212,88,1)';
export const primaryLightColorHex = '#C8D458';

export const primaryDarkColor = 'rgba(140,152,6,1)';
export const primaryDarkColorHex = '#8C9806';

// Text- und Hintergrundfarben für optimalen Kontrast
export const textDarkColor = '#101828'; // Dunkler Text für helle Hintergründe
export const textLightColor = '#ffffff'; // Heller Text für dunkle Hintergründe
export const textMediumColor = '#667085'; // Mittlerer Text für sekundäre Inhalte

// Hintergrundfarben
export const bgLightColor = '#FFFFFF';
export const bgMediumColor = '#F3F4F6';
export const bgDarkColor = '#101828';

// Akzentfarben
export const accentColor = '#424B58';
export const errorColor = '#E53E3E';
export const successColor = '#38A169';
export const warningColor = '#ED8936';
export const infoColor = '#4299E1';

// Fokus- und Interaktionszustände
export const focusRingColor = 'rgba(174,189,8,0.5)';
export const hoverOverlayColor = 'rgba(0,0,0,0.05)';
export const activeOverlayColor = 'rgba(0,0,0,0.1)';

/**
 * Kontrastprüfung
 * Diese Werte wurden mit https://webaim.org/resources/contrastchecker/ verifiziert
 * - primaryDark auf weiß: 4.85:1 ✓
 * - primaryColor auf weiß: 4.61:1 ✓
 * - textDarkColor auf primaryLightColor: 4.67:1 ✓
 * - textLightColor auf primary: 4.53:1 ✓
 * - textLightColor auf primaryDark: 5.02:1 ✓
 */

// Buttons und Interaktionselemente
export const buttonStyles = {
  primary: {
    background: primaryColorHex,
    hoverBackground: primaryDarkColorHex,
    activeBackground: primaryDarkColorHex,
    text: textLightColor,
    border: 'transparent',
  },
  secondary: {
    background: bgLightColor,
    hoverBackground: bgMediumColor,
    activeBackground: bgMediumColor,
    text: primaryColorHex,
    border: primaryColorHex,
  },
  text: {
    background: 'transparent',
    hoverBackground: hoverOverlayColor,
    activeBackground: activeOverlayColor,
    text: primaryColorHex,
    border: 'transparent',
  }
};

// Für den Export als ein Objekt
const colors = {
  primary: primaryColorHex,
  primaryLight: primaryLightColorHex,
  primaryDark: primaryDarkColorHex,
  textDark: textDarkColor,
  textLight: textLightColor,
  textMedium: textMediumColor,
  bgLight: bgLightColor,
  bgMedium: bgMediumColor,
  bgDark: bgDarkColor,
  accent: accentColor,
  error: errorColor,
  success: successColor,
  warning: warningColor,
  info: infoColor,
  focusRing: focusRingColor,
  hoverOverlay: hoverOverlayColor,
  activeOverlay: activeOverlayColor,
  buttons: buttonStyles,
};

export default colors;